<template>
  <RuleWrapper
    :class="getRuleStyling(rule.type)"
    class="pb-1 if-else-rule"
  >
    <RuleHeader
      :rule="rule"
      :rule-reference="rule.reference"
      :title="rule.type"
      :display-delete="displayDelete"
    />
    <RuleMinMaxCount
      v-if="rule.type === ruleTypeConstant.subscriptions_count"
      :rule-reference="rule.reference"
      :rule="rule"
    />
    <RuleMinMaxCount
      v-else-if="rule.type === ruleTypeConstant.ects_count"
      :rule-reference="rule.reference"
      :rule="rule"
    />
    <RuleIfElse
      v-else-if="rule.type === ruleTypeConstant.if"
      :rule-reference="rule.reference"
      :rule="rule"
    />
    <RuleComposite
      v-else-if="rule.type === ruleTypeConstant.composite"
      :rule-reference="rule.reference"
      :rules="rule.rules"
    />
    <RuleSpecificSubscription
      v-else-if="rule.type === ruleTypeConstant.specific_subscription"
      :rule-reference="rule.reference"
      :rule="rule"
    />
    <RuleNot
      v-else-if="rule.type === ruleTypeConstant.not"
      :rule-reference="rule.reference"
      :rule="rule"
    />
    <RuleOverlap
      v-else-if="rule.type === ruleTypeConstant.overlap"
      :rule-reference="rule.reference"
      :rules="rule.rules"
    />
    <RuleAggregate
      v-else-if="rule.type === ruleTypeConstant.aggregate"
      :rule-reference="rule.reference"
      :rule="rule"
    />
    <RuleStudentCharacteristic
      v-else-if="rule.type === ruleTypeConstant.student_characteristic"
      :rule-reference="rule.reference"
      :rule="rule"
    />

    <RuleDescription
      :reference="rule.reference"
      :rule="rule"
    />
  </RuleWrapper>
</template>

<script>
import { RULE_TYPE } from '@/constants'
import RuleStudentCharacteristic from '@/employees/components/Rule/RuleStudentCharacteristic.vue'
export default {
  name: 'RuleTypeShow',
  components: { RuleStudentCharacteristic },
  props: {
    rule: {
      required: true,
      type: Object,
    },
    displayDelete: {
      required: false,
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      ruleTypeConstant: RULE_TYPE,
    }
  },
  methods: {
    getRuleStyling (rule) {
      switch (rule) {
        case RULE_TYPE.composite:
          return 'composite'
        case RULE_TYPE.if:
          return 'if'
        case RULE_TYPE.not:
          return 'not'
        case RULE_TYPE.overlap:
          return 'overlap'
        case RULE_TYPE.aggregate:
          return 'aggregate'
        default:
          return ''
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.if {
  border-style: solid;
  border-width: 1px;
}
.not {
  border-style: dashed;
  border-color: red;
  border-width: 1px;
}
.overlap {
  border-left-style: solid;
  border-left-color: black;
}
.aggregate {
  border-left-style: solid;
  border-left-color: slategray;
}
.composite {
  border-left-style: solid;
  border-left-color: #006600;
}
.composite > .wrapper > .composite {
  border-left-color: #000099;
}
.composite > .wrapper > .composite > .wrapper > .composite {
  border-left-color:  #00b300;
}
.composite > .wrapper > .composite > .wrapper > .composite > .wrapper > .composite {
  border-left-color: #0000e6;
}
.composite > .wrapper > .composite > .wrapper > .composite > .wrapper > .composite > .wrapper > .composite {
  border-left-color: #00ff00;
}
.composite > .wrapper > .composite > .wrapper > .composite > .wrapper > .composite > .wrapper > .composite > .wrapper > .composite {
  border-left-color: #9999ff;
}
</style>
